import { Component, OnInit , AfterViewInit, Input , Output, EventEmitter, HostListener} from '@angular/core';
import {trigger, style, animate, transition, keyframes, state} from '@angular/animations';
import {ApiService} from "../api.service";
import {CommonService} from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";

@Component({
  selector: 'app-course-learning-home',
  animations: [
    trigger('noteAnimation', [
      state('showNote', style({transform: 'translate(0%, 0%) scale(1, 1)', zIndex: 1000001})),
      state('hideNote', style({transform: 'translate(0%, 400%) scale(0, 0)', zIndex: 0})),
      transition('hideNote => showNote', animate('300ms', keyframes([
        style({transform: 'translate(0%, 200%) scale(1, 1)'}),
        style({transform: 'translate(0%, 150%) scale(1, 1)'}),
        style({transform: 'translate(0%, 100%) scale(1, 1)'}),
        style({transform: 'translate(0%, 80%) scale(1, 1)'}),
        style({transform: 'translate(0%, 60%) scale(1, 1)'}),
        style({transform: 'translate(0%, 40%) scale(1, 1)'}),
        style({transform: 'translate(0%, 20%) scale(1, 1)'}),
        style({transform: 'translate(0%, 10%) scale(1, 1)'}),
        style({transform: 'translate(0%, 0%) scale(1, 1)'}),
      ]))),
      transition('showNote => hideNote', animate('300ms', keyframes([
        style({transform: 'translate(0%, 0%)'}),
        style({transform: 'translate(0%, 10%)'}),
        style({transform: 'translate(0%, 20%)'}),
        style({transform: 'translate(0%, 40%)'}),
        style({transform: 'translate(0%, 60%)'}),
        style({transform: 'translate(0%, 80%)'}),
        style({transform: 'translate(0%, 100%)'}),
        style({transform: 'translate(0%, 150%)'}),
        style({transform: 'translate(0%, 200%)'}),
      ])))
    ])
  ],
  templateUrl: './course-learning-home.component.html',
  styleUrls: ['./course-learning-home.component.css',]
})

export class CourseLearningHomeComponent implements OnInit , AfterViewInit {
  @Input() pathName:string;
  @Input() course:any;
  @Input() learningPathId: any;
  @Output() onLessonChosen = new EventEmitter<any>();
  @Output() onExit = new EventEmitter<any>();
  @Output() onQuestionChosen = new EventEmitter<any>();
  @Output() onimage = new EventEmitter<any>();
  //配置信息
  abilityConfig:AbilityConfig;
  @HostListener("window:scroll", ['$event']) onWindowScroll(event: Event){
    let headWrapHeightMax = 1.6 * this.commonService.rootFontSize(),
      headWrapHeightMin = 0.8 * this.commonService.rootFontSize(),
      headWrap = document.getElementById("head_wrap"),
      headTitle = document.getElementById("title2");
    if(headWrap !== null && headTitle !== null){
      if (window.pageYOffset > headWrapHeightMin) {
        headWrap.style.height = headWrapHeightMin + "px";
        headTitle.style.opacity = "1";
      } else if (window.pageYOffset == 0) {
        headTitle.style.opacity = "0";
        headWrap.style.height = headWrapHeightMax + "px";
      }
    }
  };

  courseNumber: number;
  finishedNumber: number;
  firstUnfinished: number;

  test: any;
  lessons: any;

  maskStatus: boolean;
  finishStatus: boolean;

  status: any;
  userType: any;

  positionArray: any;
  guideText:any;
  guideTextAll:any;

  scrollToDiv: boolean;
  noteShow: boolean;
  firstNoteShow: boolean;

  learningPath: any;
  learningPathMetaId: any;

  chuanjie: any;

  learningTour: boolean;
  initScroll: any;
  goPracticeFlag: boolean; //是否显示情景模拟入口
  isShowLoadingComponent: boolean;

  assetsRoute: string = "../../assets";



  constructor(private  apiService: ApiService,
              private commonService: CommonService,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(){
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    setTimeout(()=>{
      this.isShowLoadingComponent = true;
    },5000);

    this.abilityConfig = new AbilityConfig(this.apiService,this.commonService);
    let that =this;
    this.courseNumber=this.course.lessons.length;
    this.userType = window.sessionStorage.getItem('userType');
    this.setFinishedNumber();
    this.test = false;
    this.lessons = this.course.lessons;
    // if(this.userType){
    //   // this.course.lessons
    //   this.course.lessons[0].status = 0;
    //   this.lessons = this.course.lessons;
    // }else{
    //   this.lessons = this.course.lessons;
    // }
    this.firstNoteShow = false;


    this.apiService.ajax({
      'type': 'get',
      'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
    }).subscribe(result=>{
      this.learningPathMetaId = result.data;
      //alert('No.2!'+this.learningPathMetaId);
      this.apiService.getOrCreateLearningPath(this.learningPathMetaId).subscribe(result=>{
        this.learningPath = result;
        if(result.lock!==2){
          this.goPracticeFlag = true;
        }else{
          this.goPracticeFlag = false;
        }
        // console.log(this.learningPath);
      });
    });

    // 测试API
    if(this.course.name=='卓越辅导'){
      this.guideText=[{
        position:1,
        text:'辅导前，先了解这些'
      },{
        position:3,
        text:'完美辅导，怎么做？'
      },{
        position:8,
        text:'学会这些，能力升级'
      }];
    }else if(this.course.name=='团队课程'){
      this.guideText=[{
        position:1,
        text:'诊断：团队经典挑战'
      },{
        position:3,
        text:'打造：成功团队五因素'
      },{
        position:9,
        text:'打造：成功团队五因素'
      }];
    }else if(this.course.name=='授权课程'){
      this.guideText=[{
        position:1,
        text:'授权经典挑战'
      }
      ]
    }else{
      this.guideText=[{
        position:1,
        text:''
      }]
    }
    // 获取串接词
    this.apiService.ajax({
      'type': 'get',
      'url': '/api/concatenation/' + this.learningPathId,
      'data': {
        'learningPathId': this.learningPathId,
      }
    }).subscribe(comment => {
      comment.forEach(function (item,index) {
        if(item.title=='课程学习'){
          that.chuanjie = item.comment;
        }
      });
    });
    this.guideTextAll = [];
    this.positionArray = [];
    this.guideText.forEach(function (item,index) {
      that.positionArray.push(item.position-1);
    });
    let backgroundColorType = 0;
    this.lessons.forEach(function (item, index) {
      if(that.commonService.inArray(that.positionArray,index) && index != 0){
        backgroundColorType = backgroundColorType == 0?1:0;
      }
      item.backgroundColorType = backgroundColorType;
    });
    for(let i=0;i<this.lessons.length;i++){
      this.guideTextAll[i]={position:-1, text:''};
      for(let j=0;j<this.guideText.length;j++){
        if(this.guideText[j].position-1==i){
          this.guideTextAll[i]=this.guideText[j];
        }
      }
    }
    /*this.disableRoll();*/
    this.apiService.ajax({
      'type': 'post',
      'url': '/api/getUserInfo',
      'data': {}
    }).subscribe(result=>{
      this.status = result;
    });
    /*this.status = 1;*/
    this.getMaskStatus();
    // this.disableRolling2();

    if(this.finishedNumber != this.lessons.length){
      this.initScroll = setInterval(function () {
        if($('.yellowCircle').length > 0){
          clearInterval(that.initScroll);
          let top = $('.yellowCircle').offset().top;
          /* $(window).scrollTop(top-5*that.commonService.rootFontSize());*/
          $('html, body').animate({
            scrollTop: top - 5 * that.commonService.rootFontSize()
          });
        }
      }, 200);
    }


    // } else if(this.finishedNumber == this.lessons.length && !this.maskStatus && this.course.name = "沟通课程"){
    //
    //   // 提示已经完成课程
    //   $('#nextWrap').show();
    //   $("#nextWrap").animate({
    //       bottom: 0
    //   });
    //
    // }


  }

  ngAfterViewInit(){
    this.commonService.initPage();
    $('body').css("height", "auto");

  }

  setFinishedNumber() {
    this.finishedNumber = 0;
    if(this.userType){
      // this.finishedNumber = 0;
      for (let i = 0; i < this.course.lessons.length; i++){
        let preLength = 0;
        if(this.course.lessons[i].questionsGroup){
          preLength = this.course.lessons[i].questionsGroup.filter(d => d.afterClass == 2).length;
          this.course.lessons[i].preLength = preLength;
        }
        if (this.course.lessons[i].status == 2 &&(!this.course.lessons[i].questionsGroup||this.course.lessons[i].questionsGroup && (this.course.lessons[i].speed==2 || this.course.lessons[i].questionsGroup.length == preLength && this.course.lessons[i].speed==0 ))) {
          this.finishedNumber++;
        }
      }
    }else{
      for (let i = 0; i < this.course.lessons.length; i++){
        let preLength = 0;
        if(this.course.lessons[i].questionsGroup){
          preLength = this.course.lessons[i].questionsGroup.filter(d => d.afterClass == 2).length;
          this.course.lessons[i].preLength = preLength;
        }
        if (this.course.lessons[i].status == 2 &&(!this.course.lessons[i].questionsGroup||this.course.lessons[i].questionsGroup && (this.course.lessons[i].speed==2 || this.course.lessons[i].questionsGroup.length == preLength && this.course.lessons[i].speed==0 ))) {
          this.finishedNumber++;
        }
      }
      // console.log("Finished number is " + this.finishedNumber.toString());
    }

  }


  getMaskStatus() {
    if (this.course.name == '卓越辅导') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/101',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
    } else if (this.course.name == '团队课程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/111',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
    } else if (this.course.name == '授权课程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/121',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
    } else if (this.course.name == '沟通课程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/131',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/135',
        'data': {}
      }).subscribe(result => {
        this.finishStatus = result == 1 ? true : false;
        console.log(this.finishStatus);
        if (this.finishStatus) {
          $(document).ready(function () {
            $("#nextWrap").show();
            $("#nextWrap").animate({
              bottom: 0
            });
          });
        }
      });
    } else if (this.course.name == '组织与计划课程') {

      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/141',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
    } else if (this.course.name == '协作课程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/151',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
    } else if (this.course.name == '影响力课程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/161',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
    } else if (this.course.name == '影响力专业版课程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/1611',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
    } else if (this.course.name == '决策课程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/171',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
    } else if (this.course.name == '驱动变革课程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/181',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
    } else if (this.course.name == '领导力启程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/191',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/195',
        'data': {}
      }).subscribe(result => {
        this.finishStatus = result == 1 ? true : false;
        console.log(this.finishStatus);
        if (this.finishStatus) {
          $(document).ready(function () {
            $("#nextWrap").show();
            $("#nextWrap").animate({
              bottom: 0
            });
          });
        }
      });
    } else if (this.course.name == '达至最佳绩效课程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/301',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });

    } else if (this.course.name == '目标选才课程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/311',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });

    }else if (this.course.name == '解决冲突课程') {
      this.apiService.ajax({
        'type': 'get',
        'url': '/sr/onceino/321',
        'data': {}
      }).subscribe(result => {
        this.maskStatus = result == 1 ? false : true;
      });
    }
  }

  getLesson(i, k){
    // k is the video index
    // console.log(i+','+k);
    if(i <= this.finishedNumber && (!this.course.lessons[i].hasPreLesson || this.course.lessons[i].hasPreLesson &&
      (this.course.lessons[i].status == 2 || this.course.lessons[i].status == 4) ) &&
      (!this.course.lessons[i].hasMultiLesson || this.course.lessons[i].hasMultiLesson &&
      (this.course.lessons[i].status >= 20 + k || this.course.lessons[i].status == 2 || this.course.lessons[i].status == 0 && k == 0)) &&
      (this.status==1||this.status!=1&&i<=1)){
        $('body').css("height", "100%");
        this.onLessonChosen.emit([i, k]);
      }
  }

  getTip(i){
    if(this.status!=1&&i>1){
      $("#shade2").fadeIn();
      $('#tip2').fadeIn();
    }
  }

  //精华笔记
  goNote(){
    if(this.assetsRoute === 'assets'){
      let link = ["course-note", this.learningPathId, this.course.id,0];
      this.router.navigate(link);
    }else{
      this.noteShow = true;
      setTimeout(function(){
        $('#closeBtnNote').show();
      }, 300);
    }
  }

  getQuestion(i, j){
    var preLength = this.course.lessons[i].questionsGroup.filter(d => d.afterClass == 2).length;
    if(i <= this.finishedNumber&&(this.course.lessons[i].status==2 || (this.course.lessons[i].hasPreLesson && j <= preLength - 1))&&(this.status==1||this.status!=1&&i<=1)){
      $('body').css("height", "100%");
      this.onQuestionChosen.emit([i,j]);
    }
  }

  changzouwen(){
    //$('#biji1,#biji2').css({'display':'block'});
  }

  closeBiji(){
    $('#biji1,#biji2').css({'display':'none'});
  }

// 关闭精华笔记
  closeNote(){

    this.noteShow = false;
    $('#closeBtnNote').hide();
    // 如果第一次时候关闭，展示下一课的过渡
    // console.log(this.firstNoteShow);
    if(this.firstNoteShow){

      // 只显示有情景模拟的
      if(this.course.name != "沟通课程" && this.course.name != "领导力启程"&&this.course.name!="目标选才课程" ){
        $("#shade").fadeIn();
        $("#guide").show();
        $("#guide").animate({
          'top':'0.9rem'
        });
      }else if(this.course.name == "领导力启程"){
        // 提示已经完成课程
        $("#nextWrap").show();
        $("#nextWrap").animate({
          bottom: 0
        });
        // 标记完成
        this.apiService.ajax({
          'type':'post',
          'url': '/sr/onceino/195',
          'data':{}
        }).subscribe(result=>{});
      } else if(this.course.name == "沟通课程"){
        // 提示已经完成课程
        $("#nextWrap").show();
        $("#nextWrap").animate({
          bottom: 0
        });
        // 标记完成
        this.apiService.ajax({
          'type':'post',
          'url': '/sr/onceino/135',
          'data':{}
        }).subscribe(result=>{});
      }else if(this.course.name == "目标选才课程"){
        // 提示已经完成课程
        $("#nextWrap").show();
        $("#nextWrap").animate({
          bottom: 0
        });
        // 标记完成
        this.apiService.ajax({
          'type':'post',
          'url': '/sr/onceino/315',
          'data':{}
        }).subscribe(result=>{});
      } else if(this.course.name == "解决冲突课程"){
        // 提示已经完成课程
        $("#nextWrap").show();
        $("#nextWrap").animate({
          bottom: 0
        });
        // 标记完成
        this.apiService.ajax({
          'type':'post',
          'url': '/sr/onceino/325',
          'data':{}
        }).subscribe(result=>{});
      }  else {}

    }
    // $('body').css("height", "auto");

  }

  guideAnimateOut(){
		$('body').css("height", "100%");
    this.apiService.ajax({
      'type': 'get',
      'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
    }).subscribe(result=>{
      this.learningPathMetaId = result.data;
      this.apiService.ajax({
        'type':'GET',
        'url':'/sr/exposeoutapi/setAbilitySession/'+this.learningPathMetaId+'/3'
      }).subscribe(result=>{});
      //alert('No.2!'+this.learningPathMetaId);
      this.apiService.getOrCreateLearningPath(this.learningPathMetaId).subscribe(result=>{
        this.learningPath = result;
        // console.log(this.learningPath);
        this.apiService.ajax({
          'type':'get',
          'url': '/sr/learningtour',
        }).subscribe(result => {
          this.learningTour = result.pre_survey_meta_ids.length > 0 ? true: false;
          if(this.learningTour){
            if(this.learningPath.subItems.length==2){
              this.gotoPractice(1);
            }else{
              this.gotoPractice(2);
            }
          }else{
            if(this.learningPath.subItems.length == 2){
              if(this.learningPath.name=='领导力精要'){
                let link = ['learning-path',this.learningPathMetaId];
                this.router.navigate(link);
              }
            }else if(this.learningPath.subItems.length == 3 ||(this.learningPath.name=='辅导' && this.learningPath.subItems.length == 4) ||(this.learningPath.name=='打造高效团队' && this.learningPath.subItems.length == 4)||(this.learningPath.name=='驱动变革' && this.learningPath.subItems.length == 4)||(this.learningPath.name=='达至最佳绩效' && this.learningPath.subItems.length == 4)||(this.learningPath.name=='解决冲突' && this.learningPath.subItems.length == 4)){
              this.gotoPractice(2);
            }else if(this.learningPath.subItems.length >= 4){
              this.gotoPractice(2);
            }
          }
        });
      });
    });
  }

  gotoPractice(practiceIndex){
    let practiceMetaId = this.learningPath.subItems[practiceIndex].practiceMetaId;
    console.log(practiceMetaId);
    //转向情景列表
    let link = this.abilityConfig.getPracticeLinkList(this.learningPath.name,this.learningPath.id,practiceMetaId);
    if(link.length > 0){
      this.router.navigate(link);
    }
  }


  finish(){
    if(this.finishStatus){
      return;
    }else{
      let link;
      $('body').css("height", "100%");
      this.apiService.ajax({
        'type':'get',
        'url': '/sr/learningtour',
      }).subscribe(result => {
        this.learningTour = result.pre_survey_meta_ids.length > 0 ? true: false;
        if(this.learningTour){
          link = ['learning-map', 3];
          this.router.navigate(link);
        }else{
          link = ['learning-map'];
          this.router.navigate(link);
        }
      });
    }
  }

  close() {
    this.setFinishedNumber();
    if(this.status == 1){
      if(this.finishedNumber < this.courseNumber){
        $("#shade").fadeIn(300);
        $("#tip1").fadeIn(300);
      }else{
        $('body').css("height", "100%");
        this.exit();
      }
    }else{
      if(this.finishedNumber <= 1){
        $("#shade").fadeIn(300);
        $("#tip1").fadeIn(300);
      }else{
        $('body').css("height", "100%");
        this.exit();
      }
    }
  }

  continue(){
    $("#tip1").fadeOut(300);
    $("#shade").fadeOut(300);

  }

  exit(){
    $('body').css("height", "100%");
    if(this.initScroll){
      clearInterval(this.initScroll);
    }
    this.onExit.emit(true);
  }

  try(){
    $('body').css("height", "100%");
    let link = ['form', '3'];
    this.router.navigate(link);
  }

  shareHide(){

    $('#share').fadeOut();
    if(this.course.name=='卓越辅导'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/101',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='团队课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/111',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='授权课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/121',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='沟通课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/131',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='组织与计划课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/141',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='协作课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/151',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='影响力课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/161',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='影响力专业版课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/1610',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='决策课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/171',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='驱动变革课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/181',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='领导力启程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/191',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='达至最佳绩效课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/301',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='目标选才课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/311',
        'data':{}
      }).subscribe(result=>{});

    }else if(this.course.name=='解决冲突课程'){

      this.apiService.ajax({
        'type':'post',
        'url': '/sr/onceino/321',
        'data':{}
      }).subscribe(result=>{});

    } else{

    }

    if(this.assetsRoute === 'assets'){
      let link = ["course-note", this.learningPathId, this.course.id,1];
      this.router.navigate(link);
    }else{
      this.noteShow = true;
      setTimeout(function(){
        $('#closeBtnNote').show();
      }, 300);
      this.firstNoteShow = true;
    }



  }

  hideTip2(){

    $("#shade2").fadeOut();
    $('#tip2').fadeOut();

  }


  disableRolling(){
    document.getElementById('shade').ontouchstart = function(e){ e.preventDefault(); }
    document.getElementById('tip1').ontouchstart = function(e){ e.preventDefault(); }
    document.getElementById('quitBtn').ontouchstart = function(e){ e.preventDefault(); }
    document.getElementById('continueBtn').ontouchstart = function(e){ e.preventDefault(); }
  }

  disableRolling2(){
    document.getElementById('shade2').ontouchmove = function(e){ e.preventDefault(); }
    document.getElementById('tip2').ontouchmove = function(e){ e.preventDefault(); }
    document.getElementById('tipBtn2').ontouchmove = function(e){ e.preventDefault(); }
  }

  disableRoll(){
    document.getElementById('share').ontouchmove = function(e){ e.preventDefault(); }
  }

  openPDF(number){
    window.open("../../assets/pdf/jinghua11-"+number+".pdf","_blank");
  }

}



// WEBPACK FOOTER //
// ./src/app/course-learning-home/course-learning-home.component.ts